import React from 'react';
import { BellIcon, TriangleAlertIcon } from 'lucide-react';
import { priorityInsight } from '../../data/eau';
interface WaterInsightProps {
  onConfigureAlerts: () => void;
}
export function WaterInsight({
  onConfigureAlerts
}: WaterInsightProps) {
  const attention = priorityInsight.tone === 'attention';
  return <section aria-labelledby="insight-titre" className={`rounded-3xl border p-6 lg:p-7 ${attention ? 'border-ville-coral/30 bg-[#fdf3f2]' : 'border-slate-200 bg-white'}`} data-id="element-1291" data-mp="23fa71500vrr1">
      <p className={`flex items-center gap-2 text-sm font-bold ${attention ? 'text-ville-coral' : 'text-ville-indigo'}`} data-id="element-1292" data-mp="1tiyrm654ylsd">
        <TriangleAlertIcon className="h-4 w-4" aria-hidden="true" data-id="element-1293" data-mp="1kplokbdcy3sk" />
        Analyse prioritaire
      </p>
      <h2 id="insight-titre" className="mt-2 text-lg font-extrabold leading-snug tracking-tight text-ville-navy" data-id="element-1294" data-mp="15suk3notu1w3">
        {priorityInsight.title}
      </h2>
      <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-1295" data-mp="1aqw368m9617k">{priorityInsight.detail}</p>
      <button type="button" onClick={onConfigureAlerts} className="mt-4 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-navy focus-visible:ring-offset-2" data-id="element-1296" data-mp="3g6kg9jt1ji4c">
        <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-1297" data-mp="2xiyyq592h7pd" />
        M’alerter en cas de fuite
      </button>
    </section>;
}